import { render } from "./PasswordForget.vue?vue&type=template&id=6cb12298&scoped=true"
import script from "./PasswordForget.vue?vue&type=script&lang=js"
export * from "./PasswordForget.vue?vue&type=script&lang=js"

import "./PasswordForget.vue?vue&type=style&index=0&id=6cb12298&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeej-spa/eeej-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb12298"]])

export default __exports__